// Booking / scheduling configuration.

// Two-step contact flow (modelled on the Spotify/Backstage "form → calendar"
// pattern):
//   1. The visitor fills in the HubSpot qualification form below.
//   2. On submit they are sent to the HubSpot meeting scheduler to pick a time.

// HubSpot form (step 1). Leave portalId/formId empty to fall back to a plain
// email CTA. Configure these under HubSpot > Marketing > Forms > Share > Embed.
export const hubspotForm = {
  portalId: "148217137",
  formId: "164c2de9-eca3-4b76-8e5d-16c7466de90c",
  region: "eu1",
};

// HubSpot meeting scheduler (step 2). Paste the public meetings.hubspot.com
// link here — the visitor is redirected to it once the form is submitted.
// While empty, the form simply shows its own thank-you message after submit.
export const hubspotMeetingUrl =
  "https://meetings-eu1.hubspot.com/magnus-christiansson/talk-to-us";

// Direct contact email, used as a fallback CTA when the form is unavailable.
export const contactEmail = "magnus@bold-n-brave.com";
